import { ProfileAppType } from '@/core/filter/app-type.enum';
import { IProfile } from '@/types';

export const isNotificationApp = (profile: IProfile): boolean => {
  return profile.appType === ProfileAppType.MESSAGING_NOTIFICATION_APP;
};
